import { Drawer, YStack } from '@shinetools/lumen-react'
import { type ReactElement, type ReactNode, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

interface ExportDrawerProps {
  children: ReactNode
  isExportDisabled?: boolean
  isExporting?: boolean
  isOpen: boolean
  onClose: () => void
  onExport: () => void
  title: string
}

export const ExportDrawer = ({
  children,
  isExportDisabled = false,
  isExporting = false,
  isOpen,
  onClose,
  onExport,
  title,
}: ExportDrawerProps): ReactElement => {
  const { t } = useTranslation()

  const handleDrawerClose = useCallback(() => {
    onClose()
  }, [onClose])

  const handleExportClick = useCallback(() => {
    onExport()
  }, [onExport])

  return (
    <Drawer
      closeLabel={t('close')}
      onClose={handleDrawerClose}
      open={isOpen}
      primaryAction={{
        disabled: isExportDisabled,
        label: t('export_drawer.export'),
        loading: isExporting,
        onClick: handleExportClick,
      }}
      secondaryAction={{
        label: t('export_drawer.cancel'),
        onClick: handleDrawerClose,
      }}
      title={title}
    >
      <YStack gap={16}>{children}</YStack>
    </Drawer>
  )
}
